import React, {useEffect, useState } from "react";
import { getOutsourcedLeaves } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";

export default function OutsourcingLeaves() {
    const [loading, setLoading] = useState(false);
    const [leaves, setOutsourcedLeaves] = useState(null);
    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        getOutsourcedLeaves()
            .then((res) => { 
                setOutsourcedLeaves(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    return (
        <>
            <h1 className="dash-title">Outsourcing</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Leaves Requests</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && leaves && leaves) ? 
                                    <div className="table-responsive">
                                        {(leaves && leaves.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Organization</th><th>Title</th><th>Year</th><th>Month</th><th>Date</th><th>Time</th>
                                            <th>Status</th><th>View</th></tr></thead>
                                            <tbody>
                                                {leaves && leaves.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.staff?.first_name && row?.staff?.first_name} {row?.staff?.last_name && row?.staff?.last_name} </td>
                                                        <td>{row?.organization?.name && row?.organization?.name}</td>
                                                        <td>{row?.department?.name && row?.department?.name}</td>
                                                        <td>{row?.month && row?.month}</td>
                                                        <td>{row?.date && row?.date}</td>
                                                        <td>{row?.time && row?.time}</td> 
                                                        <td>{row?.status && row?.status}</td> 
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/outsourcing/townhall", row._id)} 
                                                                className='btn btn-preview'
                                                                disabled
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
